import ColorPicker from 'simple-color-picker-jq';
import 'simple-color-picker-jq/simple-color-picker.css';

declare function createCkeditorInstace(el: JQuery): void;
declare function updateRequiredLabels(): void;

/**
 * Opens a simple color picker for COLOR_TYPE settings (onclick from Settings.php).
 * Restored here after colorpicker.nais.js was removed; bundle is no longer a separate entry.
 */
function showColorPicker(el: HTMLElement, useElementValueColor?: boolean): void {
    const $elem = $(`#${el.id}`);

    if ($elem.hasClass('color-pickered')) {
        return;
    }

    const parent = $elem.parent();
    const colorpicker = new ColorPicker({
        color: useElementValueColor ? String($elem.val() ?? '#0000ff') : '#0000ff',
        // simple-color-picker-jq expects a jQuery object (appendTo uses .append)
        el: parent as unknown as HTMLElement,
    });

    colorpicker.onChange(() => {
        const hex = colorpicker.getHexString();
        $elem.val(hex);
        $elem.attr('style', `cursor: pointer;background-color: ${hex} !important`);
    });

    $elem.addClass('color-pickered');
}

export function initSystemSettings(root: HTMLElement): void {
    const checkDnsUrl = root.dataset.checkDnsUrl ?? '';
    const generateKeysUrl = root.dataset.generateKeysUrl ?? '';

    window.showColorPicker = showColorPicker;

    const bootSettingsUi = (): void => {
        $('.wysiwyg').each(function eachWysiwyg() {
            const element = $(this);

            if (typeof CKEDITOR !== 'undefined' && CKEDITOR.instances[element.attr('id') ?? '']) {
                return;
            }

            createCkeditorInstace(element);
        });

        if (typeof updateRequiredLabels === 'function') {
            updateRequiredLabels();
        }
    };

    // afterAjax re-calls initSystemModule; $(document).ready would stack handlers.
    if (document.readyState === 'loading') {
        $(document).ready(bootSettingsUi);
    } else {
        bootSettingsUi();
    }

    window.checkDns = () => {
        if (!checkDnsUrl) {
            return;
        }

        $.nette.ajax({ url: checkDnsUrl });
    };

    window.generateKeys = () => {
        if (!generateKeysUrl) {
            return;
        }

        const dictionaryElement = document.getElementById('dictionary');
        const dictionary = dictionaryElement
            ? JSON.parse(dictionaryElement.textContent || dictionaryElement.innerHTML)
            : { yes: 'Yes', no: 'No' };

        $('<div></div>').dialog({
            resizable: false,
            height: 'auto',
            width: 400,
            modal: true,
            dialogClass: 'dlg-no-close',
            closeOnEscape: true,
            title: root.dataset.generateKeysTitle ?? '',
            open() {
                $(this).html(root.dataset.generateKeysText ?? '');
            },
            buttons: [
                {
                    text: dictionary.yes,
                    click() {
                        $.nette.ajax({ url: generateKeysUrl });
                        $(this).dialog('close');
                    },
                },
                {
                    text: dictionary.no,
                    click() {
                        $(this).dialog('close');
                    },
                },
            ],
        });
    };

    $(root)
        .off('click.systemSettingsDkim', '[data-action="system-check-dkim-dns"]')
        .on('click.systemSettingsDkim', '[data-action="system-check-dkim-dns"]', (event) => {
            event.preventDefault();
            window.checkDns?.();
        });

    $(root)
        .off('click.systemSettingsGenerateKeys', '[data-action="system-generate-dkim-keys"]')
        .on('click.systemSettingsGenerateKeys', '[data-action="system-generate-dkim-keys"]', (event) => {
            event.preventDefault();
            window.generateKeys?.();
        });
}
